import React from 'react'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CarDetail from "../carbookstatus/carDetail";
import TripDetail from "../../../pages/myBooking/tripStatus/mainTripDetail";

const bookingtripcar = () => {
  return (
    <div>
     <Row className="content">
          <Col lg={9} className="px-0  main-trip-wrap">
            <TripDetail />
          </Col>
          <Col lg={3} className=" px-0 car-col">
            <CarDetail />
          </Col>
        </Row>
    
    </div>
  )
}

export default bookingtripcar